import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProductContext = createContext({ product: null, offset: 0, reload: () => {} });

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);

export const eur2 = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);

const CDN = "https://customer-assets-4nw71qhi.emergentagent.net/job_midea-12000-btu/artifacts";

export const IMAGES = {
  packSide: `${CDN}/de865469e6563070_media.jpg.webp`,
  packStacked: `${CDN}/a86b07480c6a86de_A1bfb81ae680a43ee93328790a04efed1M.png_220x220.png.webp`,
  office: `${CDN}/f85c04f29e7200ee_media.jpg-2.webp`,
  outdoorWindow: `${CDN}/6a94aa6873eaf92a_media.jpg-3.webp`,
  hoseWindow: `${CDN}/b1d920798bc177c3_media.jpg-4.webp`,
  attic: `${CDN}/742fc75a33b7a4c4_media.jpg-5.webp`,
  bracket: `${CDN}/f79f9b7be243bf03_media.jpg-6.webp`,
  app: `${CDN}/757c0e2c40ff210b_media.jpg-7.webp`,
  silence: `${CDN}/04645cdf9a0949f8_media.jpg-8.webp`,
  energyLabel: `${CDN}/8ac090c94251e690_media.jpg-10.webp`,
  exploded: "/images/vue-eclatee.webp",
};

export const ProductProvider = ({ children }) => {
  const [product, setProduct] = useState(null);
  const [offset, setOffset] = useState(0);

  const reload = useCallback(async () => {
    const { data } = await axios.get(`${API}/product`);
    setOffset(new Date(data.server_time).getTime() - Date.now());
    setProduct(data);
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return <ProductContext.Provider value={{ product, offset, reload }}>{children}</ProductContext.Provider>;
};

export const useProduct = () => useContext(ProductContext);

export const promoEndLabel = (iso) =>
  new Intl.DateTimeFormat("fr-FR", { timeZone: "Europe/Paris", day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" })
    .format(new Date(iso))
    .replace(":", "h");
